import { render } from "./NooDles.vue?vue&type=template&id=f564af86"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/NooDles.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f564af86"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f564af86', __exports__)) {
    api.reload('f564af86', __exports__)
  }
  
  module.hot.accept("./NooDles.vue?vue&type=template&id=f564af86", () => {
    api.rerender('f564af86', render)
  })

}


export default __exports__